import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { PromoText } from 'components/no-auth/common/promo-text/PromoText';

import promoMedia from 'theme/promoMedia';

import PromoComplexPopup from '../../popup/PromoComplexPopup';
import { PromoButton } from '../promo-button/PromoButton';
import { PromoRow } from '../PromoRow/PromoRow';

const QrCode = styled.figure`
    width: 136px;

    img {
        border: none;
        max-width: 100%;
        vertical-align: top;
    }

    ${promoMedia.tablet744} {
        width: 248px;
    }
`;

const QRCodePopup = (props) => {
    return (
        <PromoComplexPopup withoutButton popupRef={props.popupRef}>
            <PromoRow indent={'16px'}>
                <PromoText color="gray80" tag="div" variant="h3">
                    {props.popupTitle}
                </PromoText>
            </PromoRow>
            <PromoRow indent={'16px'}>
                <PromoText color="gray40" tag="div" variant="subheader">
                    {props.popupSubTitle}
                </PromoText>
            </PromoRow>
            {props.img && (
                <PromoRow indent={'24px'}>
                    <QrCode>
                        <img src={props.img?.[0].url} alt={''} />
                    </QrCode>
                </PromoRow>
            )}
            <PromoRow textAlign={'right'}>
                <PromoButton caption={props.btnCaption} type={'link'} href={props.btnHref} id={'continueOnWeb'} />
            </PromoRow>
        </PromoComplexPopup>
    );
};

QRCodePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    popupTitle: PropTypes.string,
    popupSubTitle: PropTypes.string,
    img: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        popupTitle: state.extra?.strapiApi?.qr_code_popup?.title,
        popupSubTitle: state.extra?.strapiApi?.qr_code_popup?.subtitle,
        img: state.extra?.strapiApi?.qr_code_popup?.img,
        btnCaption: state.extra?.strapiApi?.qr_code_popup?.btn_cta?.title,
        btnHref: state.extra?.strapiApi?.qr_code_popup?.btn_cta?.url,
    };
};
export default connect(mapStateToProps, null)(QRCodePopup);
